import { Grid2 } from "@mui/material";
import { PropsWithChildren } from "react";
import { Outlet } from "react-router-dom";
import { getFullBodyLayoutStyles } from "@components/page-layout/full-body-layout-styles";

/**
 * Describes the layout for full body pages i.e: account setting page, add credits page. Includes the header bar,
 * and the "Outlet", in which the router will inject every page content.
 */
export function FullBodyLayout({ children }: PropsWithChildren): JSX.Element {
  const { contentWrapper, content } = getFullBodyLayoutStyles();

  return (
    <Grid2
      container
      justifyContent="center"
      data-testid="CONTENT_WRAPPER"
      sx={{
        width: "100%",
        px: contentWrapper.px,
        pt: contentWrapper.pt,
      }}
    >
      <Grid2
        data-testid="CONTENT"
        sx={{
          width: "100%",
          maxWidth: content.maxWidth,
        }}
      >
        {/* <Outlet> is a placeholder for the active child route defined in the routes.ts */}
        {children ? children : <Outlet />}
      </Grid2>
    </Grid2>
  );
}
